export function isOtaConfigured(): boolean {
  return Boolean(
    process.env.PHRASE_DISTRIBUTION_ID?.trim() && process.env.PHRASE_OTA_ENVIRONMENT?.trim(),
  );
}

export function getOtaBackendOptions(): {
  distribution: string;
  environment: string;
  cacheExpirationTime: number;
  format: 'i18next_4';
} {
  return {
    distribution: process.env.PHRASE_DISTRIBUTION_ID ?? '',
    environment: process.env.PHRASE_OTA_ENVIRONMENT ?? '',
    cacheExpirationTime: 300,
    format: 'i18next_4',
  };
}
